// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"TestMetrics_headerWrapper__2pUwg","clockGroup":"TestMetrics_clockGroup__CbAwC","navigationWrapper":"TestMetrics_navigationWrapper__qf4tj"};